import React from "react";
import styled from "styled-components";

const TournamentSelector = ({
  tournaments,
  currentTournament,
  setCurrentTournament,
}) => {
  return (
    <PillRow>
      {tournaments.map((tournament) => (
        <Pill
          key={tournament.tournamentId}
          $active={currentTournament === tournament.tournamentId}
          onClick={() => setCurrentTournament(tournament.tournamentId)}
        >
          {tournament.name.replace("Temporada ", "T")}
        </Pill>
      ))}
    </PillRow>
  );
};

const PillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
`;

const Pill = styled.div`
  padding: 0.4rem 0.85rem;
  border: 1px solid ${({ $active }) => ($active ? "var(--v-mint)" : "rgba(255, 255, 255, 0.08)")};
  background: ${({ $active }) => ($active ? "rgba(60, 255, 208, 0.08)" : "transparent")};
  color: ${({ $active }) => ($active ? "var(--v-mint)" : "var(--v-fg)")};
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: var(--v-mint);
  }
`;

export default TournamentSelector;
